export default __webpack_public_path__ + "static/media/dark_box_icon.609de6ad.svg";